import PlayerJerseyModal from 'components/Player/PlayerJerseyModal';
import RelationsTable from 'components/RelationsTable';
import useEntities from 'hooks/useEntities';
import { useState } from 'react';
import useLoginStore from 'store/loginStore';
import icons from 'utils/icons';

const PlayerJerseys = ({ sourceEntityId, sourceEntityData, teams, data, onChange }) => {
    const entities = useEntities();
    const [isJerseyModalOpen, setJerseyModalOpen] = useState(false);
    const isAdmin = useLoginStore(s => s.isAdmin)();

    // Check if current user can edit jerseys for this player
    const canEditJerseys = isAdmin || 
                          sourceEntityData?.status === 'DRAFT' || 
                          sourceEntityData?.status === 'INVITED';

    const removeClicked = async (id) => {
        await entities.Jersey.delete(id);
        onChange();
    }

    const createClicked = async () => {
        setJerseyModalOpen(true);
    }

    const jerseModalOk = async (data) => {
        await entities.Jersey.create({
            ...data,
            name: data.teamName + ' - ' + data.number,
            playerId: sourceEntityId,
        });
        onChange();
        setJerseyModalOpen(false);
    }

    const jerseModalCancel = async () => {
        setJerseyModalOpen(false);
    }

    return (
        <div>
            <PlayerJerseyModal
                teams={teams}
                open={isJerseyModalOpen}
                onOk={jerseModalOk} 
                onCancel={jerseModalCancel}
            />

            <RelationsTable
                data={data}
                sourceEntity={entities.Player}
                targetEntity={entities.Jersey}
                emptyMessage="This player does not have any Jerseys"
                addButton={canEditJerseys && {
                    label: 'Add Jersey',
                    icon: icons.Link,
                    onClick: createClicked,
                }}
                columns={[
                    { ...entities.Jersey.columns['TeamWithLogo'], defaultSortOrder: 'ascend' },
                    { ...entities.Jersey.columns['number'] },
                ]}
                sourceEntityId={sourceEntityId}
                removeClicked={canEditJerseys && removeClicked}
                rowClickable={false}
            />
        </div>
    );
}

export default PlayerJerseys
